import { PageObject } from "../../pages/admin/Translations"

export const setLanguage = (data:"N" | "F" | "E") => {
    return {
        type: 'SET_LANGUAGE',
        payload: data
    }
}

export const setContent = (data:PageObject) => {
    return {
        type: 'SET_CONTENT',
        payload: data || {}
    }
}

export const setUserData = (data:UserData | null) => {
    return {
        type: 'SET_USERDATA',
        payload: data
    }
}

export const setUsers = (data:Users) => {
    return {
        type: 'SET_USERS',
        payload: data
    }
}

export const setNotification = (data:NotificationObject | null) => {
    return {
        type: 'SET_NOTIFICATION',
        payload: data
    }
}

export const setFavoriteDocuments = (data:DocumentObject[]) => {
    return {
        type: 'SET_FAVORITEDOCUMENTS',
        payload: data
    }
}

export const setDocgroups = (data:DocgroupObject[]) => {
    return {
        type: 'SET_DOCGROUPS',
        payload: data
    }
}

export const setDoctypes = (data:DoctypeObject[]) => {
    return {
        type: 'SET_DOCTYPES',
        payload: data
    }
}

export const setMetatypes = (data:any) => {
    return {
        type: 'SET_METATYPES',
        payload: data
    }
}

export const setDossiers = (data:DossierObject[]) => {
    return {
        type: 'SET_DOSSIERS',
        payload: data
    }
}

export const setDossiertypes = (data:any) => {
    return {
        type: 'SET_DOSSIERTYPES',
        payload: data
    }
}

export const setActions = (data:Action[]) => {
    return {
        type: 'SET_ACTIONS',
        payload: data
    }
}

export const setColleagues = (data:ForwardUser[]) => {
    return {
        type: 'SET_COLLEAGUES',
        payload: data
    }
}